import React from "react";
import { useTranslation } from "react-i18next";

function View(props) {
  const { t } = useTranslation("auth");
  return (
    <div id="login-wrapper">
      <img
        className="logo"
        src="/img/msb-logo-white.svg"
        alt={t("privacyPolicy.logoAlt")}
      />
      <div className="frame">
        <h1 className="alt">{t("privacyPolicy.title")}</h1>
        <p>{t("privacyPolicy.paragraph1")}</p>
        <p>{t("privacyPolicy.paragraph2")}</p>
        <p>{t("privacyPolicy.paragraph3")}</p>
        <p>{t("privacyPolicy.paragraph4")}</p>
        <p>{t("privacyPolicy.paragraph5")}</p>
        <p>
          {t("privacyPolicy.paragraph6")}{" "}
          <a href="mailto:info@mystrengthbook.com">
            {t("privacyPolicy.contactUs")}
          </a>
          .
        </p>
      </div>
    </div>
  );
}

const PrivacyPolicy = (app) => {
  app.get("/privacy-policy", ({ res }) => (res.body = <View />));
};

export default PrivacyPolicy;
